import { render } from "./DocumentSplit.vue?vue&type=template&id=f4ec8746&scoped=true&ts=true"
import script from "./DocumentSplit.vue?vue&type=script&lang=ts"
export * from "./DocumentSplit.vue?vue&type=script&lang=ts"

import "./DocumentSplit.vue?vue&type=style&index=0&id=f4ec8746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ec8746"]])

export default __exports__